var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenFolderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.25,
    height: 54.167,
    viewBox: "0 0 81.25 54.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-folder-open",
    "data-name": "Icon awesome-folder-open",
    d: "M80.784,36.675,70.568,54.188a9.027,9.027,0,0,1-7.8,4.479H6.351a3.385,3.385,0,0,1-2.924-5.091L13.643,36.062a9.028,9.028,0,0,1,7.8-4.479H77.86a3.385,3.385,0,0,1,2.924,5.091ZM21.441,27.069H67.708V20.3a6.771,6.771,0,0,0-6.771-6.771H38.368L29.34,4.5H6.771A6.771,6.771,0,0,0,0,11.271V50.492l9.744-16.7A13.588,13.588,0,0,1,21.441,27.069Z",
    transform: "translate(0 -4.5)",
    fill: "#e6e7eb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenFolderIcon);
export default __webpack_public_path__ + "static/media/OpenFolderIcon.4d59a25e9869d25f689ab74d286d152e.svg";
export { ForwardRef as ReactComponent };